import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const navigationItems = [
    { name: 'Home', href: '/' },
    { name: 'About', href: '/about' },
    { name: 'Charters', href: '/charters' },
    { name: 'Resources', href: '/resources' },
    { name: 'Membership', href: '/membership' },
    { name: 'Contact', href: '/contact' }
  ];

  const handleNavClick = (href: string) => {
    navigate(href);
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 w-full z-50" style={{ background: 'rgba(61, 44, 141, 0.95)', backdropFilter: 'blur(10px)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer group" onClick={() => navigate('/')}>
            <div className="w-12 h-12 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-xl flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300">
              <i className="ri-crown-line text-white text-2xl"></i>
            </div>
            <div>
              <span className="font-bold text-2xl bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent" style={{ fontFamily: '"Playfair Display", serif' }}>
                CROWN
              </span>
              <div className="text-xs text-white/80 -mt-1">House of CROWN</div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.href)}
                className="text-white/90 hover:text-amber-400 font-medium transition-all duration-300 cursor-pointer whitespace-nowrap relative group py-2"
              >
                {item.name}
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-amber-400 to-yellow-300 group-hover:w-full transition-all duration-300"></div>
              </button>
            ))}
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <button 
              onClick={() => handleNavClick('/login')}
              className="text-white/90 hover:text-amber-400 font-medium transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-login-box-line mr-2"></i>
              Login
            </button>
            <button 
              onClick={() => handleNavClick('/membership')}
              className="bg-gradient-to-r from-amber-500 to-yellow-400 hover:from-amber-600 hover:to-yellow-500 text-white px-8 py-3 rounded-xl font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <i className="ri-crown-line mr-2"></i>
              Join CROWN
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-3 rounded-xl text-white hover:text-amber-400 transition-colors duration-200 hover:bg-white/10"
          >
            <i className={isMenuOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-6 border-t border-white/20">
            <nav className="flex flex-col space-y-4">
              {navigationItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-white/90 hover:text-amber-400 font-medium transition-colors duration-200 text-left cursor-pointer py-2"
                >
                  {item.name}
                </button>
              ))}
              <button 
                onClick={() => handleNavClick('/login')}
                className="text-white/90 hover:text-amber-400 font-medium transition-colors duration-200 text-left cursor-pointer py-2"
              >
                <i className="ri-login-box-line mr-2"></i>
                Login
              </button>
              <button 
                onClick={() => handleNavClick('/membership')}
                className="bg-gradient-to-r from-amber-500 to-yellow-400 text-white px-6 py-3 rounded-xl font-semibold w-fit mt-4 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-crown-line mr-2"></i>
                Join CROWN
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
